import React from 'react'
import QuickAccessCard from './index'
import { QuickAccessCardListContainer } from './styled'

const QuickAccessCardList = ({ items = [] }) => {
	return (
		<QuickAccessCardListContainer>
			{items.map(item => (
				<QuickAccessCard
					key={item.id || item.urlRedirect || item.text}
					text={item.text}
					leftIcon={item.leftIcon}
					righIcon={item.righIcon}
					urlRedirect={item.urlRedirect}
					onClick={item.onClick}
					type={item.type}
				/>
			))}
		</QuickAccessCardListContainer>
	)
}

export default QuickAccessCardList
